import {TaskType} from '@toolify/client/src/stores/TaskStore/enum/TaskType'
import {ITaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/ITaskTypeStrategy'
import {DownloadTaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/DownloadTaskTypeStrategy'
import {UploadTaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/UploadTaskTypeStrategy'
import {GenericTaskTypeStrategy} from '@toolify/client/src/stores/TaskStore/strategies/GenericTaskTypeStrategy'

const taskTypeStrategies: Array<[TaskType, ITaskTypeStrategy<TaskType>]> = [
  [TaskType.Download, DownloadTaskTypeStrategy as ITaskTypeStrategy<TaskType>],
  [TaskType.Upload, UploadTaskTypeStrategy as ITaskTypeStrategy<TaskType>],
  [TaskType.Generic, GenericTaskTypeStrategy as ITaskTypeStrategy<TaskType>],
]

export const TaskTypeStrategyMap = new Map<TaskType, ITaskTypeStrategy<TaskType>>(taskTypeStrategies)

